import React, { useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../Login/CreateUser.css";
import { FaLock, FaRegUserCircle } from "react-icons/fa";
import { LuEyeOff, LuEye } from "react-icons/lu";
import { toast } from "react-toastify";
import axios from "axios";
import { APIUrl, APIUrlToken, SetlocalStorage } from "../../Utils/Utils";
import { MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const CreateUser = () => {
  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;

  const validateFields = () => {
    const { userName, email, password, confirmPassword } = formData;
    if (!userName.trim()) {
      toast.error("Please enter User Name");
      return false;
    }
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid Email");
      return false;
    }
    if (!password.trim()) {
      toast.error("Please enter Password");
      return false;
    }
    if (!passwordRegex.test(password)) {
      toast.error(
        "Password must contain at least 8 characters, including one uppercase, one lowercase, one special symbol, and one number"
      );
      return false;
    }
    if (!confirmPassword.trim()) {
      toast.error("Please enter Confirm Password");
      return false;
    }
    if (password !== confirmPassword) {
      toast.error("Confirm Password must match Password");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateFields()) return;
    setLoading(true);
    const url = `${APIUrl()}/v1/local/auth/register?user_name=${formData.userName}&user_email=${formData.email}&password=${encodeURIComponent(formData.password)}`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    try {
      const response = await axios(options);
      toast.success("User created successfully!");
      navigate("/Login")
    } catch (error) {

      toast.error(error?.response?.data?.detail || "Error creating user. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="content-section-changepass">
          <h3>Create User</h3>
          <div className="profile-container-changepass">
            <div className="profile-card-changepass">
              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaRegUserCircle />
                  </div>
                  <input
                    type="text"
                    className="form-control-changepass-user"
                    name="userName"
                    placeholder="User Name"
                    value={formData.userName}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <MdEmail />
                  </div>
                  <input
                    type="email"
                    className="form-control-changepass-user"
                    name="email"
                    placeholder="User Email"
                    value={formData.email}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaLock />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control-changepass"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  {showPassword ? (
                    <LuEye className="eye-svg" onClick={toggleShowPassword} />
                  ) : (
                    <LuEyeOff className="eye-svg" onClick={toggleShowPassword} />
                  )}
                </div>
              </div>
              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaLock />
                  </div>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control-changepass"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  {showConfirmPassword ? (
                    <LuEye className="eye-svg" onClick={toggleShowConfirmPassword} />
                  ) : (
                    <LuEyeOff className="eye-svg" onClick={toggleShowConfirmPassword} />
                  )}
                </div>
              </div>
              <div className="button-section-changepass-user">
                <button onClick={handleSubmit} disabled={loading}>
                  {loading ? "Creating..." : "Create Account"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CreateUser;
